module.exports = __webpack_public_path__ + "img/sorter-checked-icon.6b085b8e.svg";